export const handleErrorMessage = (errorMessage: string | null) => {
    switch (errorMessage) {
        case 'Invalid or expired token':
            return 'Unauthorized. You need to authorize as an admin.';
        default:
            return errorMessage;
    }
};